import BaseApi from '../base';

class DrugApi extends BaseApi {
  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getCatalogs(token) {
    return this.makeRequest(this.METHOD_GET, 'catalogs', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getDrugs(token) {
    return this.makeRequest(this.METHOD_GET, 'items', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getFormats(token) {
    return this.makeRequest(this.METHOD_GET, 'formats', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getIngredients(token) {
    return this.makeRequest(this.METHOD_GET, 'ingredients', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getMethods(token) {
    return this.makeRequest(this.METHOD_GET, 'methods', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getTimes(token) {
    return this.makeRequest(this.METHOD_GET, 'times', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getStats(token) {
    return this.makeRequest(this.METHOD_GET, 'prescriptions/stats', token);
  }

  /**
   * @param {string} token
   * @param {number} id
   * @returns {Promise<*>}
   */
  async getPrescriptions(token, id) {
    return this.makeRequest(this.METHOD_GET, `prescriptions?user=${id}`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addPrescription(token, data) {
    return this.makeRequest(this.METHOD_POST, 'prescriptions', token, data);
  }

  /**
   * @param {string} token
   * @param {number} prescriptionId
   * @param data
   * @returns {Promise<*>}
   */
  async updatePrescription(token, prescriptionId, data) {
    return this.makeRequest(this.METHOD_POST, `prescriptions/${prescriptionId}`, token, data);
  }

  /**
   * @param {string} token
   * @param {number} prescriptionId
   * @returns {Promise<*>}
   */
  async archivePrescription(token, prescriptionId) {
    return this.makeRequest(this.METHOD_POST, `prescriptions/${prescriptionId}/archive`, token);
  }

  /**
   * @param {string} token
   * @param {number} prescriptionId
   * @returns {Promise<*>}
   */
  async restorePrescription(token, prescriptionId) {
    return this.makeRequest(this.METHOD_POST, `prescriptions/${prescriptionId}/restore`, token);
  }

  /**
   * @param {string} token
   * @param {number} prescriptionId
   * @returns {Promise<*>}
   */
  async deletePrescription(token, prescriptionId) {
    return this.makeRequest(this.METHOD_POST, `prescriptions/${prescriptionId}/delete`, token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getFavoritesPrescriptions(token) {
    return this.makeRequest(this.METHOD_GET, 'prescriptions/favorites', token);
  }

  /**
   * @param {string} token
   * @param {number} id
   * @returns {Promise<*>}
   */
  async addPrescriptionToFavorites(token, id) {
    return this.makeRequest(this.METHOD_POST, `prescriptions/${id}/favorites/add`, token);
  }

  /**
   * @param {string} token
   * @param {number} id
   * @returns {Promise<*>}
   */
  async removePrescriptionFromFavorites(token, id) {
    return this.makeRequest(this.METHOD_POST, `prescriptions/${id}/favorites/remove`, token);
  }
}

export default DrugApi;
